// @flow
import React, { Component } from 'react';
import authAction from 'app/common/react/components/limitedLogin/authAction';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import withViewer from 'app/common/lib/react/withViewer';
import { GRID_ITEM_WIDTH } from 'app/common/lib/react/gridUtils';
import { track } from 'app/common/lib/react/analytics';
import { type State as Viewer } from 'app/common/redux/reducers/viewer';
import { Box, Icon, Card, Text } from 'gestalt';

const ADD_CIRCLE_ICON_SIZE = 40;
type AddPinRepProps = {
  ctaText?: string,
  viewer: Viewer,
  height?: number,
  iconSize?: number,
  textSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  handleClick?: () => void,
};

export class AddPinRep extends Component<AddPinRepProps> {
  handleAddPin = () => {
    const { viewer, handleClick } = this.props;
    if (handleClick) {
      handleClick();
    }
    if (viewer.isPartner) {
      track(PCONST.thrift.EventType.CLICK, {
        component: PCONST.thrift.ComponentType.FLOWED_PIN,
        element: PCONST.thrift.ElementType.CREATE_PIN_BUTTON,
      });
    }
  };

  render() {
    return (
      <Box>
        <NavigateLink to={'/pin-builder/'} onClick={authAction(this.handleAddPin)}>
          <Card>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="lightGray"
              shape="rounded"
              height={this.props.height || GRID_ITEM_WIDTH}
              width={this.props.height || undefined}
              fit
            >
              <Box
                height={this.props.iconSize || ADD_CIRCLE_ICON_SIZE}
                shape="circle"
                width={this.props.iconSize || ADD_CIRCLE_ICON_SIZE}
                color="white"
              >
                {/* Disabling the label since otherwise this text is being read twice */}
                <Icon
                  accessibilityLabel=""
                  color="red"
                  icon="add-circle"
                  inline
                  size={this.props.iconSize || ADD_CIRCLE_ICON_SIZE}
                />
              </Box>
            </Box>
            <Box padding={2}>
              <Text color="gray" size={this.props.textSize || 'lg'} weight="bold">
                {this.props.ctaText || i18n._('Create Pin', 'label to open create pin modal')}
              </Text>
            </Box>
          </Card>
        </NavigateLink>
      </Box>
    );
  }
}

export default withViewer(AddPinRep);
